<template>
    <!-- Begin:Search/TabBox -->
    <div class="search-box-wrapper style1">
        <div class="search-box">
            <ul class="search-tabs clearfix">
                <!-- Begin:FlightSearchTabs-Booking ************************ -->
                <li class="active" v-if="modulo === 'booking'">
                    <a href="#flights-tab" data-toggle="tab">
                        <i class="soap-icon-plane-right takeoff-effect"></i>
                        {{ searchboxflights[getCurrentLocale] }}
                    </a>
                </li>



                <!-- Begin:FlightSearchTabs-Services *********************** -->
                <li class="active" v-if="modulo === 'services'">
                    <a href="#flights-tab" data-toggle="tab">
                        <i class="soap-icon-plane-right takeoff-effect"></i>
                        {{ searchboxflights_services[getCurrentLocale] }}
                    </a>
                </li>



                <!-- Begin:FlightSearchTabs-Rebooking ********************** -->
                <li class="active" v-if="modulo === 'rebooking'">
                    <a href="#rebooking-tab" data-toggle="tab">
                        <i class="soap-icon-plane-right takeoff-effect"></i>
                        {{ searchboxrebooking[getCurrentLocale] }}
                    </a>
                </li>



                <!-- Begin:FlightSearchTabs-Flighttransfer ***************** -->
                <li class="active" v-if="modulo === 'flighttransfer'">
                    <a href="#flighttransfer-tab" data-toggle="tab">
                        <i class="soap-icon-plane-right takeoff-effect"></i>
                        {{ searchboxflighttransfer[getCurrentLocale] }}
                    </a>
                </li>


                <!-- Begin:FlightSearchTabs-Addinafnt ********************** -->
                <li class="active" v-if="modulo === 'addinfant'">
                    <a href="#addinfant-tab" data-toggle="tab">
                        <i class="soap-icon-plane-right takeoff-effect"></i>
                        {{ searchboxaddinfant[getCurrentLocale] }}
                    </a>
                </li>
            </ul>


            <div class="visible-mobile">
                <ul id="mobile-search-tabs" class="search-tabs clearfix">
                    <!-- Begin:FlightSearchTabs-Booking ******************** -->
                    <li class="active" v-if="modulo === 'booking'">
                        <a href="#flights-tab">{{ searchboxflights[getCurrentLocale] }}</a>
                    </li>



                    <!-- Begin:FlightSearchTabs-Services ******************* -->
                    <li class="active" v-if="modulo === 'services'">
                        <a href="#flights-tab">{{ searchboxflights_services[getCurrentLocale] }}</a>
                    </li>



                    <!-- Begin:FlightSearchTabs-Rebooking ****************** -->
                    <li class="active" v-if="modulo === 'rebooking'">
                        <a href="#rebooking-tab">{{ searchboxrebooking[getCurrentLocale] }}</a>
                    </li>



                    <!-- Begin:FlightSearchTabs-Flighttransfer ************* -->
                    <li class="active" v-if="modulo === 'flighttransfer'">
                        <a href="#flighttransfer-tab">{{ searchboxflighttransfer[getCurrentLocale] }}</a>
                    </li>


                    <!-- Begin:FlightSearchTabs-Addinfant ****************** -->
                    <li class="active" v-if="modulo === 'addinfant'">
                        <a href="#addinfant-tab">{{ searchboxaddinfant[getCurrentLocale] }}</a>
                    </li>
                </ul>
            </div>


            <div class="search-tab-content">
                <!-- Begin:FlightSearchTabs-Booking ************************ -->
                <div class="tab-pane fade active in" id="flights-tab" v-if="modulo === 'booking'">
                    <sdr-shared-flightsearch-tab :modulo="modulo"></sdr-shared-flightsearch-tab>
                </div>



                <!-- Begin:FlightSearchTabs-Services *********************** -->
                <div class="tab-pane fade active in" id="flights-tab" v-if="modulo === 'services'">
                    <sdr-shared-flightsearch-tab :modulo="modulo"></sdr-shared-flightsearch-tab>
                </div>



                <!-- Begin:FlightSearchTabs-Rebooking ********************** -->
                <div class="tab-pane fade active in" id="rebooking-tab" v-if="modulo === 'rebooking'">
                    <sdr-shared-rebooking-tab></sdr-shared-rebooking-tab>
                </div>



                <!-- Begin:FlightSearchTabs-Flighttransfer ***************** -->
                <div class="tab-pane fade active in" id="flighttransfer-tab" v-if="modulo === 'flighttransfer'">
                    <sdr-shared-flighttransfer-tab></sdr-shared-flighttransfer-tab>
                </div>


                <!-- Begin:FlightSearchTabs-Addinfant ********************** -->
                <div class="tab-pane fade active in" id="addinfant-tab" v-if="modulo === 'addinfant'">
                    <sdr-shared-addinfant-tab></sdr-shared-addinfant-tab>
                </div>
            </div>
        </div>
    </div>
    <!-- End:Search/TabBox -->
</template>

<script>
    import FlightSearchTab from '../../shared/flightsearch/FlightSearchTab.vue'; // Tab::'FlightSearch' (shared)
    import BookingnoTab from '../../shared/forms/BookingnoTab.vue'; // Tab::'Bookingno' (Services)
    import RebookingTab from '../../shared/forms/RebookingTab.vue'; // Tab::'Rebooking' (Rebooking)
    import FlighttransferTab from '../../shared/forms/FlighttransferTab.vue'; // Tab::'Flighttransfer' (Flighttransfer)
    import AddinfantTab from '../../shared/forms/AddinfantTab.vue'; // Tab::'Addinfant' (Addinfant)

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-shared-flightsearch-tab': FlightSearchTab,
            'sdr-shared-bookingno-tab': BookingnoTab,
            'sdr-shared-rebooking-tab': RebookingTab,
            'sdr-shared-flighttransfer-tab': FlighttransferTab,
            'sdr-shared-addinfant-tab': AddinfantTab,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                searchboxflights: {
                    en: 'Flights',
                    de: 'Flüge',
                },
                searchboxpackagetours: {
                    en: 'Package tour',
                    de: 'Pauschalreise',
                },

                searchboxflights_services: {
                    en: 'Find your Flight',
                    de: 'Ihren Flug finden',
                },
                searchboxbookingno_services: {
                    en: 'Find your booking',
                    de: 'Ihre Buchung finden',
                },
                searchboxseat: {
                    en: 'Seats',
                    de: 'Sitzplätze',
                },
                searchboxluggage: {
                    en: 'Luggage',
                    de: 'Gepäck',
                },
                searchboxrebooking: {
                    en: 'Rebooking Flights',
                    de: 'Flüge umbuchen',
                },
                searchboxhelp: {
                    en: 'Help & Contact',
                    de: 'Hilfe & Kontakt',
                },
                searchboxflighttransfer : {
                    en: 'Flighttransfer',
                    de: 'Flugumbuchung',
                },
                searchboxaddinfant: {
                    en: 'Add Infant',
                    de: 'Kleinkind hinzufügen',
                }
                // currentLocale: 'de',
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/

    };
</script>





